import { lazy } from 'react';
import { Home } from 'lucide-react';
import { createRoute } from './utils';

// Lazy load dashboard components
const Dashboard = lazy(() => import('@/pages/Dashboard'));

// Dashboard related routes
export const dashboardRoutes = [
  // Dashboard - index route
  createRoute(undefined, <Dashboard />, 'Dashboard', Home, { index: true }),
];
